module.exports = {"331121001":"鹤城街道","331121002":"瓯南街道","331121003":"油竹街道","331121101":"温溪镇","331121102":"东源镇","331121103":"高湖镇","331121104":"船寮镇","331121105":"海口镇","331121106":"腊口镇","331121107":"北山镇","331121108":"山口镇","331121109":"仁庄镇","331121200":"万山乡","331121201":"黄垟乡","331121202":"季宅乡","331121203":"高市乡","331121204":"海溪乡","331121205":"章村乡","331121206":"祯旺乡","331121207":"祯埠乡","331121208":"舒桥乡","331121209":"巨浦乡","331121211":"万阜乡","331121212":"方山乡","331121213":"汤垟乡","331121214":"贵岙乡","331121215":"小舟山乡","331121216":"吴坑乡","331121217":"仁宫乡","331121218":"章旦乡","331121219":"阜山乡","331121220":"石溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331121.json
// module id = 1027
// module chunks = 0